import { Folder, Info, X } from '@phosphor-icons/react';
import { format } from 'date-fns';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import pdfIcon from './../../../../../../../assets/svg/attachmentPdfIcon.svg';

import otherFileTypeIcon from '../../../../../../../assets/svg/otherFileType.svg';
import videoIcon from '../../../../../../../assets/svg/videoIcon.svg';

import { Text } from '~/components/ui/text';
import {
  DOC_FILE_TYPES,
  IMAGE_FILE_TYPES,
  PDF_FILE_TYPE,
  VIDEO_FILE_TYPES,
} from '~/constants/fileTypeConstants';
import {
  DOC_MIME_TYPE,
  IMAGE_MIME_TYPES,
  PDF_MIME_TYPE,
  VIDEO_MIME_TYPES,
} from '~/constants/mimeTypeConstants';
import { useAppSelector } from '~/hooks/global/typedReduxHooks';
import { setDisplayFile, setFileDetails } from '~/slices/reportDataSlice';

export const ShowItemDetails = () => {
  const dispatch = useDispatch();

  const { viewDetails } = useAppSelector((state) => state.reportData);

  const getIcon = (currfileType: string) => {
    if (IMAGE_FILE_TYPES.includes(currfileType)) return viewDetails.url;
    if (IMAGE_MIME_TYPES.includes(currfileType)) return viewDetails.url;
    if (VIDEO_FILE_TYPES.includes(currfileType)) return videoIcon;
    if (VIDEO_MIME_TYPES.includes(currfileType)) return videoIcon;
    if (DOC_FILE_TYPES.includes(currfileType)) return otherFileTypeIcon;
    if (DOC_MIME_TYPE === currfileType) return otherFileTypeIcon;
    if (PDF_FILE_TYPE === currfileType) return pdfIcon;
    if (PDF_MIME_TYPE === currfileType) return pdfIcon;

    return otherFileTypeIcon;
  };

  return (
    <div className='z-10 fixed right-0 top-0 bottom-0 w-[22%] min-w-[320px] border border-[#D6D6D6] bg-white overflow-y-auto'>
      <div className='relative'>
        <button
          className='absolute top-4 right-4'
          onClick={() => {
            dispatch(setDisplayFile(false));
            dispatch(setFileDetails());
          }}
        >
          <X size={27} color='#9d9d9d' />
        </button>

        <div className='p-5 w-full'>
          <div className='flex flex-column items-center gap-2'>
            <Info size={30} color='#9d9d9d' />
            <Text level='body-lg'>Information</Text>
          </div>

          {viewDetails.is_folder && (
            <div className='w-full min-h-60 flex items-center justify-center basis-2/3 mt-10'>
              <Folder size={200} color='#00cecf' weight='fill' />
            </div>
          )}
          {!viewDetails.is_folder && (
            <div className='w-full min-h-60 flex items-center justify-center basis-2/3 mt-10'>
              <img
                src={getIcon(viewDetails.file_type)}
                alt='file icon'
                className='hover:cursor-pointer'
              />
            </div>
          )}
        </div>

        <hr className='w-full' />
        <div className='flex flex-col gap-5 w-full p-7'>
          {/* this one is always at the bottom */}
          <Text level='title-lg' className='justify-start text-left truncate'>
            {viewDetails.is_folder ? (
              <FormattedMessage defaultMessage='Folder details' />
            ) : (
              <FormattedMessage defaultMessage='File details' />
            )}
          </Text>

          <div className='w-full'>
            <Text
              level='body-sm'
              className='w-full justify-start text-left text-neutral-400 capitalize truncate'
            >
              <FormattedMessage defaultMessage='Name' />
            </Text>
            <Text
              level='title-md'
              className='w-full justify-start text-left truncate capitalize'
            >
              {viewDetails.name || 'N/A'}
            </Text>
          </div>

          <div className='w-full'>
            <Text
              level='body-sm'
              className='w-full justify-start text-left text-neutral-400 capitalize truncate'
            >
              <FormattedMessage defaultMessage='Type' />
            </Text>
            <Text
              level='title-md'
              className='w-full justify-start text-left truncate capitalize'
            >
              {viewDetails.file_type || 'N/A'}
            </Text>
          </div>

          {viewDetails.file_size && (
            <div className='w-full'>
              <Text
                level='body-sm'
                className='w-full justify-start text-left text-neutral-400 capitalize truncate'
              >
                <FormattedMessage defaultMessage='Size' />
              </Text>
              <Text
                level='title-md'
                className='w-full justify-start text-left truncate capitalize'
              >
                {viewDetails.file_size.toLocaleString('en-US') || 'N/A'} KB
              </Text>
            </div>
          )}

          <div className='w-full'>
            <Text
              level='body-sm'
              className='w-full justify-start text-left text-neutral-400 capitalize truncate'
            >
              <FormattedMessage defaultMessage='Owner' />
            </Text>
            <Text
              level='title-md'
              className='w-full justify-start text-left truncate capitalize'
            >
              {viewDetails.uploader_name || 'N/A'}
            </Text>
          </div>

          <div className='w-full'>
            <Text
              level='body-sm'
              className=' w-fulljustify-start text-left text-neutral-400 capitalize truncate'
            >
              <FormattedMessage defaultMessage='Last modified' />
            </Text>
            <Text
              level='title-md'
              className=' w-fulljustify-start text-left truncate'
            >
              {format(new Date(viewDetails.last_modified), 'MMMM dd, yyyy') ||
                'N/A'}
            </Text>
          </div>

          <div className='w-full'>
            <Text
              level='body-sm'
              className='w-full justify-start text-left text-neutral-400 capitalize truncate'
            >
              <FormattedMessage defaultMessage='Created' />
            </Text>
            <Text
              level='title-md'
              className='w-full justify-start text-left truncate'
            >
              {format(new Date(viewDetails.created_at), 'MMMM dd, yyyy') ||
                'N/A'}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};
